import type { ClauseListKey } from '@root/@types/types';
import { isNonNullish } from '@root/helpers';
import { CLAUSE_TYPE_IDS } from '@root/helpers/clauses';
import { escape } from 'lodash-es';
import { parse } from 'node-html-parser';

import { getMentionLabelSegment } from './get-mention-label-segment';
import { sanitizeHtml } from './sanitize-html';

export const replaceMention = (id: string, value: string | number, content?: string): string | undefined => {
  if (!isNonNullish(value)) {
    return restoreMention(id, content);
  }

  // React 19: Always use virtual DOM to avoid direct document mutation
  const doc = parse(content ?? '');

  const mentionsArePresent = doc.querySelectorAll('[data-type="mention"]').length > 0;

  if (!mentionsArePresent) {
    return content;
  }

  const element = doc.querySelectorAll(`[data-id="${id}"]`);

  if (element) {
    element.forEach((el) => {
      if (typeof value === 'string' && value?.startsWith('<span class="mention-list-item">')) {
        el.innerHTML = String(sanitizeHtml(value));
        el.classList.add('mention-list');
      } else if (CLAUSE_TYPE_IDS.includes(id as ClauseListKey)) {
        // node-html-parser's textContent setter does not encode — raw `&`/`<`/`>` would corrupt the block HTML
        el.textContent = escape(String(value));
        el.classList.add('mention-list-placeholder');
      } else {
        el.textContent = escape(String(value));
      }
      el.classList.remove('mention');
      el.classList.add('mention-data');
    });
  }

  return doc.toString();
};

export const restoreMention = (id: string, content?: string): string | undefined => {
  // React 19: Always use virtual DOM to avoid direct document mutation
  const doc = parse(content ?? '');

  const element = doc.querySelectorAll(`[data-id="${id}"]`);
  const labelSegment = getMentionLabelSegment(id);

  if (element) {
    element.forEach((el) => {
      el.textContent = String(`{{${labelSegment}`);
      el.classList.add('mention');
      el.classList.remove('mention-data');
    });
  }

  return doc.toString();
};
